import { publicApi } from '@/shared/lib/publicAxios.ts';
import type {
  PublicStatusResponse,
  PublicUptimeResponse,
  PublicIncidentsResponse,
  PublicMaintenancesResponse,
  PublicProbesResponse,
} from './types.ts';

export async function fetchPublicStatus() {
  const { data } = await publicApi.get<PublicStatusResponse>('/status');
  return data;
}

export async function fetchPublicUptime() {
  const { data } = await publicApi.get<PublicUptimeResponse>('/uptime');
  return data;
}

export async function fetchPublicIncidents() {
  const { data } = await publicApi.get<PublicIncidentsResponse>('/incidents');
  return data;
}

export async function fetchPublicMaintenances() {
  const { data } = await publicApi.get<PublicMaintenancesResponse>('/maintenances');
  return data;
}

export async function fetchPublicProbes(from: string, to: string) {
  const { data } = await publicApi.get<PublicProbesResponse>('/probes', {
    params: { from, to },
  });
  return data;
}
